module.exports = __webpack_public_path__ + "img/techbuddy-logo.5d27f6bd.png";